module.exports = __webpack_public_path__ + "static/media/country_az.378417a1.webp";